export const IG_POSTS = []; // Instagram post shortcodes (e.g. "C8ZcuhGPbAq") from post URLs — when set, real IG embeds render on project pages

export const PROFILE_PHOTO =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_jare-studio/artifacts/5yppo5ia_hf_20260917_050005_3fe1e792-7eb8-43c6-ae9f-354c12f9f56b%20%282%29.webp";

export const EMAIL = "fajarruslaiman@gmail.com";

export const SOCIALS = [
  { label: "Instagram", handle: "@just.jareee", url: "https://instagram.com/just.jareee" },
  { label: "TikTok", handle: "@just.jareee", url: "https://tiktok.com/@just.jareee" },
  { label: "LinkedIn", handle: "Fajar Ruslaiman", url: "https://www.linkedin.com/in/fajarruslaiman/" },
  { label: "WhatsApp", handle: "0822 1188 8484", url: "https://wa.me/6282211888484" },
];

export const CATEGORIES = [
  "All",
  "Graphic Design",
  "Branding",
  "Motion Design",
  "Video Editing",
  "UI/UX",
  "Web Development",
];

export const ADMIN_CATEGORIES = CATEGORIES.slice(1).map((c) =>
  c === "UI/UX" ? "UI/UX" : c
);

export const SERVICES = [
  {
    n: "01",
    title: "Graphic & Motion Design",
    desc: "Brand identity, campaign design, motion graphics, animated branding, social media.",
    items: ["Brand Identity", "Campaign Design", "Motion Graphics", "Social Content"],
  },
  {
    n: "02",
    title: "Video Editing",
    desc: "Short-form content, commercial editing, social media video, storytelling.",
    items: ["Short-Form Content", "Commercial Editing", "Colour Grading", "Storytelling"],
  },
  {
    n: "03",
    title: "UI Design",
    desc: "Website interfaces, landing pages, digital products, design systems.",
    items: ["Web Interfaces", "Landing Pages", "Digital Products", "Design Systems"],
  },
  {
    n: "04",
    title: "Web Development",
    desc: "Portfolio sites, landing pages, web experiences, CMS-driven builds.",
    items: ["Portfolio Sites", "Landing Pages", "Web Experiences", "CMS Builds"],
  },
  {
    n: "05",
    title: "Public Speaker",
    desc: "Design talks, creative workshops, community sessions, knowledge sharing.",
    items: ["Design Talks", "Workshops", "Community Events", "Mentoring"],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "JARE rebuilt our identity with a restraint we didn't know we needed. The brand finally feels as expensive as the product.",
    name: "Claire Aurele",
    role: "Founder, Maison AURELE",
  },
  {
    quote:
      "The launch film outperformed every asset we'd ever shipped. Rhythm, grade, typography — nothing was left to chance.",
    name: "Dmitri Kovac",
    role: "Marketing Lead, HELIX Games",
  },
  {
    quote:
      "A rare designer who thinks in systems and edits like a filmmaker. Our dashboard now feels like a product, not a spreadsheet.",
    name: "Ingrid Nordvik",
    role: "CPO, Nordvik Finance",
  },
];
